export const DELIVERED = 'DELIVERED'
export const SENT = 'SENT'
export const READ = 'READ'
